import { Fragment, useContext } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import BrandContext from "./BrandContext";
import img1 from './assets/ecommerce-landingpage-1.png'
import img2 from './assets/ecommerce-landingpage-2.png'
import img3 from './assets/ecommerce-landingpage-3.png'
import img4 from './assets/ecommerce-landingpage-4.png'

export default function Home(props) {
    const theme = useContext(BrandContext);
    return (
        <Fragment>
            <Container fluid="md" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                <Row>
                    <Col md="7" style={{ padding: "15px" }}>
                        <Image style={{ width: "250px", marginBottom: "24px" }} fluid src={theme?.marketing?.logo}></Image>
                        <h4>Your Message. Our Audience.</h4>
                        <h1>Immediate Awareness</h1>
                        <p>Submit your press release through our platform to receive guaranteed community awareness and an enriched story, while also enabling a streamlined, easier to review editorial workflow.</p>
                        <LinkContainer to="email">
                            <Button variant="swiftrev">Post a Press Release</Button>
                        </LinkContainer>
                    </Col>
                    <Col md="5" style={{ padding: "15px", display: "grid", alignContent: "end" }} >
                        <Image fluid src={img1}></Image>
                    </Col>
                </Row>
                <Row className="bg-swiftrev text-white" style={{ margin: "25px 0 0 0" }}>
                    <Col md="7" style={{ padding: "35px" }}>
                        <p style={{ fontSize: "28px" }}>An Opportunity for Exposure to {(theme?.marketing?.audience || 0).toLocaleString()} Experts in the {theme?.marketing?.industries[0]} Industry</p>
                        <LinkContainer to="email">
                            <Button variant="outline-light">Get Started</Button>
                        </LinkContainer>
                    </Col>
                    <Col md="5" style={{ padding: "35px" }}>
                        <div style={{ fontSize: "28px" }}>Only</div>
                        <div style={{ fontSize: "50px", fontWeight: "bolder" }}>{theme?.priceSymbol}{theme?.price} {theme?.priceAbbr}</div>
                        <div><small>Self Checkout. Pay via Credit Card.</small></div>
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{ marginTop: "25px", padding: "25px" }}>
                    <Col md="7" style={{ padding: "15px" }}>
                        <div className="sr-alert-light">
                            <p className="h3">The audience you're looking for.</p>
                            <p>Looking to reach experts in the {theme?.marketing?.industries[0]} industry?<br />You've come to the right place.</p>
                            <p className="h5">Average Monthly Audience Reach</p>
                            <p>{(theme?.marketing?.audience || 0).toLocaleString()}</p>
                            <p className="h5">Top Industries Served</p>
                            <p>
                                {(theme?.marketing?.industries || []).map((i, indx) => <span key={`k${indx}`}>- {i}<br /></span>)}
                            </p>
                            <p className="h5">Top Job Functions</p>
                            <p>
                                {(theme?.marketing?.jobs || []).map((i, indx) => <span key={`k${indx}`}>- {i}<br /></span>)}
                            </p>
                        </div>
                    </Col>
                    <Col md="5" style={{ padding: "15px", display: "grid", alignContent: "start" }}>
                        <Image fluid src={img2}></Image>
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{ marginTop: "25px", padding: "25px" }}>
                    <Col md="5" style={{ padding: "15px", display: "grid", alignContent: "end" }}>
                        <Image fluid src={img3}></Image>
                    </Col>
                    <Col md="7" style={{ padding: "15px" }}>
                        <div className="sr-alert-light" >
                            <p className="h3">Reach our audience in minutes.</p>
                            <p>Through a quick self-posting processs, our Press Release service
                                makes it easy to bring your announcements to our audience. Your
                                purchase includes: </p>
                            <p>
                                - A quick process using your online press release link<br />
                                - Content enrichment, magnifying your organization's story<br />
                                - Supporting content for editors to understand impact faster<br />
                                - Immediate visibility in our press release feed
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row hidden={true} className="justify-content-center bg-black text-white" style={{ marginTop: "25px", padding: "25px" }}>
                    <Col md="12" className="text-center" style={{ padding: "15px" }}>
                        <p className="h4">One Click Press Release Posting</p>
                        <p>Post your press release online? Supply the link and we'll do the rest. It's that easy.*</p>
                        <LinkContainer to="email">
                            <Button variant="outline-light">Submit Your Press Release</Button>
                        </LinkContainer>
                        <div style={{ marginTop: "16px", fontStyle: "italic" }}>*We support prnewswire.com and prweb.com services</div>
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{ marginTop: "25px", padding: "25px" }}>
                    <Col md="7" style={{ padding: "15px" }}>
                        <div className="sr-alert-light">
                            <p className="h3">Your story, enriched</p>
                            <p>In addition to going live in our Press Release Channel, we also deliver a custom “SwiftRev Report” to our editor, wrapping your press release with extra decision-enabling info about your organization, including:</p>
                            <p>- Company Logo<br />
                                - Founding Date<br />
                                - Specialties<br />
                                - Number of Employees<br />
                                - Public or Private<br />
                                - Stock Ticker and Trends</p>
                        </div>
                    </Col>
                    <Col md="5" style={{ padding: "15px", display: "grid", alignContent: "end" }}>
                        <Image fluid src={img4}></Image>
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{ marginTop: "25px", padding: "25px" }}>
                    <Col md="12" style={{ padding: "15px" }} className="justify-content-center text-center">
                        <div className="d-flex justify-content-center" style={{ marginBottom: "20px" }}>
                            <Image style={{ height: "100px" }} fluid src={theme?.marketing?.logo}></Image>
                        </div>
                        <LinkContainer to="email">
                            <Button variant="outline-swiftrev">Post a Press Release</Button>
                        </LinkContainer>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}